const POTENTIAL_PARTNER_EMAIL_KEY = 'POTENTIAL_PARTNER_EMAIL_KEY';

export function getPotentialPartnerEmailCode(): string | null {
  return window.sessionStorage.getItem(POTENTIAL_PARTNER_EMAIL_KEY);
}

export function setPotentialPartnerEmailCode(data: string) {
  window.sessionStorage.setItem(POTENTIAL_PARTNER_EMAIL_KEY, data);
}
